import {http} from '../utils'
// 营销分组管理 start
// 查询
const searchAction = (params) => {
  const url = `/market/management/email/template/list`
  return http.post(url, params)
}
// 获取status列表
const getStatus = (type) => {
  const url = `/market/common/codeList/${type}`
  return http.post(url)
}
// 获取预发送效果检测列表
const getTemplateStatus = (params) => {
  const url = `/market/management/email/template/status`
  return http.post(url, params)
}
// 获取group列表
const getGroup = (params) => {
  const url = '/market/management/group/all'
  return http.post(url, params)
}
// 获取 详情
const getAction = (params) => {
  const url = `/market/management/email/template/detail`
  return http.post(url, params)
}
// 新建
const addAction = (params) => {
  const url = `/market/management/email/template/add`
  return http.post(url, params)
}
// 编辑
const editAction = (params) => {
  const url = `/market/management/email/template/edit`
  return http.post(url, params)
}
// 删除
const deleteAction = (params) => {
  const url = `/market/management/email/template/del`
  return http.post(url, params)
}
// 地址解析为htmlStr
const htmlToTemplateAction = (params) => {
  const url = `/market/management/email/htmlToTemplate`
  return http.post(url, params)
}

export default {
  searchAction,
  getStatus,
  getTemplateStatus,
  getGroup,
  getAction,
  addAction,
  editAction,
  deleteAction,
  htmlToTemplateAction
}
